var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3272 14.8739C50.2616 26.541 45.1217 40.2914 33.8137 45.7082C30.5242 47.3749 27.0289 48 23.5338 48C20.861 48 18.1883 47.5834 15.7211 46.75C11.6091 45.2916 8.11392 42.7915 5.44115 39.458C4.20755 37.9997 3.17956 36.333 2.35717 34.4579C-0.110013 29.0411 -0.726808 22.9992 0.917979 17.374C0.917979 16.9573 1.12358 16.5406 1.32918 16.1239C3.38516 10.2904 7.29152 5.70692 12.6371 2.79016C12.8426 2.58181 13.2539 2.37348 13.4594 2.37348C16.1322 1.12343 18.8051 0.290074 21.6834 0.0817329C23.7394 -0.126607 26.001 0.0817327 28.057 0.498414L28.2625 8.83202L27.2346 8.62368C23.7394 7.79033 20.2442 8.207 16.9547 9.87372C13.0483 11.9571 10.1699 15.0822 8.93632 19.0408C7.49713 22.9992 7.90832 27.3743 9.5531 31.1244C9.96431 31.7495 10.1699 32.3744 10.5811 32.9995C12.4315 35.9162 15.1043 37.9997 18.3938 39.2497C21.2722 40.2914 24.5618 40.4998 27.4402 39.6664C28.4682 39.458 29.2906 39.0414 30.3186 38.6246C35.6641 36.1246 38.7481 30.7078 39.1592 25.0825C39.1592 22.9992 38.9537 20.9158 38.1313 18.8323L35.4584 20.2908L35.0473 3.62352L40.5984 7.99866L48 13.8322L45.3272 14.8739Z",
    fill: "#E84F4F",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconError);
export default __webpack_public_path__ + "static/media/TH-Icon-Error.91c6e9fe4c369cc87d426b827f2e2c33.svg";
export { ForwardRef as ReactComponent };